import {useEffect, useRef, useState} from "react";
import {BrowserRouter, useLocation, useNavigate} from "react-router-dom";
import {Sparkles} from "lucide-react";
import {apiPost} from "@/lib/api";
import Shell from "@/pages/Shell";
import ControlPanel from "@/pages/ControlPanel";
import "@/App.css";
import "@/feature.css";
import "@/basket.css";
import "@/gfi.css";
import "@/mobile.css";
import "@/round14.css";
import "@/round15.css";

function Callback() {
  const once = useRef(false);
  const nav = useNavigate();
  const [status, setStatus] = useState("Finishing your welcome...");
  useEffect(() => {
    if (once.current) return;
    once.current = true;
    const id = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    apiPost("/auth/session", {session_id: id})
      .then(() => {
        const p = sessionStorage.getItem("pending_rfq");
        return p ? apiPost("/requests", JSON.parse(p)).then(() => sessionStorage.removeItem("pending_rfq")) : null;
      })
      .then(() => {
        window.history.replaceState({}, "", window.location.pathname);
        nav(window.location.pathname.startsWith("/control") ? "/control" : "/");
      })
      .catch(() => setStatus("We could not complete Google sign-in. Please try again."));
  }, [nav]);
  return (
    <div className="auth-callback" data-testid="auth-callback">
      <Sparkles size={30} />
      <h2>{status}</h2>
      <p>Your session is being secured privately.</p>
    </div>
  );
}

function Router() {
  const l = useLocation();
  if (l.hash.includes("session_id=")) return <Callback />;
  return l.pathname.startsWith("/control") ? <ControlPanel /> : <Shell />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Router />
    </BrowserRouter>
  );
}
